export const DocumentView = (url, isPdf, isVideo) => {
  if (isPdf) {
    return `<iframe src="https://docs.google.com/gview?url=${encodeURIComponent(
      url
    )}&embedded=true" 
              style="width:100%; height:100%; border:none;"
              sandbox="allow-same-origin allow-scripts"
              oncontextmenu="return false;"></iframe>`;
  }
  if (isVideo) {
    return `
    <div style="width:100%; height:100%; display:flex; justify-content:center; align-items:center; background:#000;">
      <video 
        style="max-width:100%; max-height:100%;" 
        oncontextmenu="return false;"
        controls
        controlslist="nodownload noplaybackrate noremoteplayback"
        disablePictureInPicture
      >
        <source src="${url}" type="video/webm">
        <source src="${url}" type="video/mp4">
      </video>
    </div>`;
  }
  return `<div style="width:100%; height:100%; display:flex; justify-content:center; align-items:center; background:#000;">
            <img src="${url}" style="max-width:100%; max-height:100%;" oncontextmenu="return false;" draggable="false"/>
          </div>`;
};
